// extracted by mini-css-extract-plugin
export var label = "_4-2";
export var logo = "_4-1";
export var topNav = "_4-0";